import React, { FC, useMemo } from 'react';
import { Layout, Row, Col, Card } from 'antd';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { DATE_FORMAT, dateFormatter } from '../../utils/DataFormatterUtils';
import PaginatedReduxTable from '../paginated_redux_table/PaginatedReduxTable';
import { EmptyState } from '../empty_state/EmptyState';
import { assetHistoryRestCrudThunksForSupplier } from '../../thunks/asset_history_thunks';
import LocationStockLocationNameWithType from '../equipment_per_stock_location_row_display/LocationStockLocationNameWithType';

const { Content } = Layout;

const AssetHistoryDetailPage: FC<any> = ({ match }): React.ReactElement => {
	const assetId = useMemo(() => match.params.id, [match.params.id]);

	const columns = useMemo(
		() => [
			{
				title: 'Location Name',
				dataIndex: 'locationId',
				render: (_, record) => (
					<LocationStockLocationNameWithType
						record={record}
						backLinkText={'Back to Transfer history'}
					/>
				),
			},
			{
				title: 'Usage',
				dataIndex: 'locationId',
				render: (_, record) => (record.locationId ? 'In Use' : 'At warehouse'),
			},
			{
				title: 'From date',
				dataIndex: 'markedTransferredToCurrentLocationAt',
				render: (val) => (val ? dateFormatter(val, DATE_FORMAT) : '__'),
			},
			{
				title: 'To date',
				dataIndex: 'markedTransferredFromCurrentLocationAt',
				render: (val) => (val ? dateFormatter(val, DATE_FORMAT) : '__'),
			},
		],
		[]
	);

	return (
		<Content style={{ padding: '0 0.5em' }}>
			<LogOnMountWithStandardEventProperties eventType={`Visited asset history detail page`} />

			<Row style={{ margin: '0.5em -8px' }} gutter={16}>
				<Col span={24}>
					<Card bodyStyle={{ padding: 8 }}>
						<PaginatedReduxTable
							mode="list"
							emptyState={
								<EmptyState
									graphic={
										<img
											alt="No asset history found"
											style={{ marginBottom: 8 }}
											src="https://s3.amazonaws.com/mock-data-assets/categories/images/box.svg"
										/>
									}
									headline={'No asset history found'}
									body={null}
								/>
							}
							collectionName="asset_history"
							targetCollectionName="assetHistoryIndex"
							columns={columns}
							showHeader
							keyAccessor={(el) => el.id}
							initialFilters={{ assetId }}
							fetchData={assetHistoryRestCrudThunksForSupplier.read}
						/>
					</Card>
				</Col>
			</Row>
		</Content>
	);
};

export default withRouter<any, any>(connect()(AssetHistoryDetailPage));
